<template>
  <div class="wrapper">
    <SideBar/>
    <TitleSection title="Collaborations" image_src="collaboration-bg.png"/>
    <ProgressBar :elements="section_elements"/>
    <Section :pin="section_elements[0].ref" color="white" :wave="false">
      <div class="elements">
        <h2 class="heading">Aachen</h2>
        <div class="element slideshow">
          <p class="text" style="width:50%;">
            To spread knowledge about how interesting and important synthetic biology is, iGEM Aachen asked us to post a picture of Plushy, the stuffed animal in the form of a microbe, on our Instagram account. In the description, the concept of synthetic biology was explained, along with examples of notable synthetic biology solutions for current issues. Additionally, we also clarified some common misconceptions on synthetic biology. Plushy was sent to many iGEM teams around the world and it thereby contributed to the public awareness of synthetic biology.           </p>
          <SlideShow name="slideshow1" width="40%" :elements="this.slideshow_elements"/>
        </div>
      </div>
    </Section>
    <Section :pin="section_elements[1].ref" color="white" :wave="false">
      <div class="elements">
        <h2 class="heading">Bio_Brussels</h2>
        <div class="element">
          <p class="text">
            During talks about partnership and sharing our data to gather further evidence for our proof of concept, our team and Bio_Brussels decided to reflect upon the iGEM competition in itself. This led to the idea of forming a survey intended for iGEM teams regarding their experience in the iGEM competition. The goal of the survey was to show prospective participants what it means to be part of an iGEM team. Furthermore, it is our hope that the answers given by the teams in this survey will be considered by iGEM, and that they will be used to ensure that future teams have the best possible experience in the competition. 
            <br><br></p>
            <div align="center">
          <SlideShow name="slideshow2" width="70%" :elements="this.slideshow_elements_brussels"/>
            </div>
        </div>
      </div>
    </Section>
    
    <Section :pin="section_elements[2].ref" color="white" :wave="false">
      <div class="elements">
        <div class="element">
          <p class="text">
            The response rate was fairly low, with 12 teams responding to the survey. Therefore, significant conclusions cannot be drawn from  these results. Nonetheless, these results can serve as a source of inspiration  for the iGEM community and future iGEM teams.
<br><br><b>Distribution strategy:</b>
<br><br>We sent the survey to 100 iGEM teams via Instagram and to 50 iGEM teams via email.

<br><br><b>Results:</b>
<br><br>What parts of iGEM did you think worked successfully?
<br><br>60% of the participants found the sense of community provided by iGEM the most successful part of iGEM.

<br><br><b>Communication by the iGEM organisational team</b>
<br><br>On a scale of one to five, 41.7% of the responding iGEM teams gave communication with the iGEM organisation team a three. 33.3% reflected communication with the iGEM organisation with a number higher than 3, whilst 25% reflected communication with the iGEM organisation with a number lower than three. 36.4% recommended the iGEM organisation to be more responsive. 27.3% recommended developing a better iGEM community platform. 



            </p>
        </div>
      </div>
    </Section>

    
    <Section :pin="section_elements[3].ref" color="white" :wave="false">
      <div class="elements">
        <div class="element">
          <p class="text">
<b>Clarity on deadlines offered by the iGEM organisational team</b><br><br>
66.6% gave the clarity of deadlines given by iGEM a three or four on a scale of one to five. 37.5% of the iGEM teams suggested the iGEM community provide final deadlines earlier. 25% recommended having a system to change time zones on the website.<br><br>

<b>Clarity of the outline of medal criteria</b><br><br>
50% of the participating iGEM teams found the outline of the medal criteria clear. 25% found it hard to know how much depth was expected. 25% found it hard to interpret integrated human practices in particular.<br><br>

<b>Transparency on costs to participate in the iGEM competition</b><br><br>
83.3% found that the transparency on costs in participation in the competition (entrance fee and jamboree) is low, and would like more information.<br><br>

<b>Transparency on finding and reaching other iGEM teams</b><br><br>
50% of the participants gave the transparency on finding and reaching other iGEM teams a four on a scale of one to five. 25% of the participants gave it a five and the other 25% of the participants gave it a two or three. 89% of the participating iGEM teams recommend creating a central platform for all iGEM teams to reach out to eachother.<br><br>
            </p>
        </div>
      </div>
    </Section>

    <Section :pin="section_elements[4].ref" color="light-blue" wave="light-blue-on-white">
      <div class="elements">
        <h2 class="heading">Puzzle Book</h2>
        <div class="element slideshow">
          <p class="text" style="width:45%;">
            We decided to create a project of our own that would inform the public about synthetic biology and iGEM, as well as enable this year's iGEM teams to promote their idea. 
<br><br>
Children and elderly might have the most difficulty accessing information about synthetic biology. To help promote iGEM's mission, we wanted to present the information in a way that would be engaging to people within those groups. Together with the fact that puzzles have shown to be a good teaching tool, we settled on making a puzzle book (Al-Furqon, 2017; Vossoughi & Zargar, 2009)
<br><br> </p>
<img style="width:45%;" src="https://static.igem.wiki/teams/4185/wiki/puzzle-vertical.jpeg"/>       
        </div>
      </div>
    </Section>
    <Section :pin="section_elements[5].ref" color="light-blue" >
      <div class="elements">

        <div class="element">
          <p class="text">
To create the book, we needed help. We reached out to various teams and asked for ten words that would best describe their projects. These words were then used to create a word search puzzle specific to each team. The book consists of many puzzles, each one promoting a specific team. Additionally, the participating teams were asked to provide us with a short 150-word description of their project, as well as the reasoning behind choosing these specific words. All of this information was included at the end of the puzzle book. The idea behind this design was to grab the puzzle solver's attention with ten keywords. As the solver goes on with the puzzles, their interest is piqued and they will want to learn more about how these words relate to the specific project and what the project is about. All that can be done by referring to the end of the puzzle book.
<br><br>
Our puzzle book includes 23 word search puzzles. The first puzzle is about synthetic biology in general, as it aims to be an introduction to the subject. The other 22 puzzles are about 22 different projects from 22 different iGEM teams. The teams that collaborated into making the word search puzzles are: Aachen, Wego_Taipei, Bio-Brussels, Patras, PuiChing_Macau, Freiburg, Barcelona_UB, Estonia_TUIT, Unicamp_Brazil, BOKU-Vienna and Bonn-Rheinbach, MiamiU, William_and_Mary, Uni-Hamburg, Montpellier, Warwick, Crete, Patras_Uni_Hellas, WLC-Milwaukee, TU_Braunschweig and MIT_MAHE.
<br><br>
          
          <a target="blank" href="https://static.igem.wiki/teams/4185/wiki/puzzle-book-msp-igem-collaboration.pdf"
          >Click here for puzzle book</a> 
</p>
        </div>
      </div>
    </Section>
    <Section :pin="section_elements[6].ref" color="light-blue" :wave="false">
      <div class="elements">
        <h2 class="heading">iGEM CityU_HongKong and CUHK-HongKong-SBS</h2>
        <div class="element slideshow">
          <p class="text" style="width:45%;" >
            To spread the knowledge about synthetic biology we took part in a collaboration activity called SynBiOOTD organized by CityU_HongKong and CUHK-HongKong-SBS. For their collaboration activity, we posted one Instagram post about a synthetic biology technique which is important to our project; Mini Prep.           </p>
          <SlideShow name="slideshow3" width="50%" :elements="this.slideshow_elements_miniprep"/>
          
        </div>
      </div>
    </Section>

    <Section :pin="section_elements[7].ref" color="light-blue">
      <div class="elements">
        <h2 class="heading">More Collaborations</h2>
        
        <div class="element">
          <p class="text">
            <b> iGEM Wego_Taipei </b>
            We collaborated with Wego_Taipei by being part of their podcast series, Eutro in Vitro. This podcast series is about how synthetic biology can be a solution for environmental issues. They interviewed us about the problem we want to tackle, what impact our project has on society, the purpose and significance of our project and our future project plans and ideas. 
<br>
<a target="blank" href="https://open.spotify.com/show/0C2VM4MngWrLqsO1IEMLk6"
          >Click here for the spotify link</a> 
        </p>

<p class="text">
  <b>iGEM UCopenhagen </b> 
  We contributed to the collaboration video of iGEM UCopenhagen about the importance of water. We recorded one team member standing in front of the river saying a word in the native language that describes the river. We decided to record the word “Geschiedenis” which is Dutch for the English word “history”. </p>
  <a target="blank" href="https://drive.google.com/file/d/12aXgIk84GVPJQT71QCDJFdJaRGh-Wh9Q/view?usp=sharing"
          >Click here for the video</a> 
          <p class="text">
            <b> iGEM WLC-Milwaukee </b>
            We collaborated with iGEM WLC by proofreading a manual that they had written about how farmers use soil as a soil test kit. Their aim is to make a more accessible and cheaper test kit for farmers and therefore their instruction manual has to be easy to understand. We think this a good idea and we therefore wanted to collaborate. We are convinced that proofread a text, the better it becomes. 
          <a target="blank" href="https://static.igem.wiki/teams/4185/wiki/igem-f22-instructions-draft1.pdf"
          >Click here for the manual</a> 
        </p>

        </div>
      </div>

    </Section>
    
    <Section :pin="section_elements[8].ref" color="dark-blue" wave="dark-blue-on-light-blue">
      <div class="elements">
        <h2 class="heading">References</h2>
        <div class="element">
          <p class="text ref">
            Al-Furqon, A. S. (2017). The Effect Of Word Search Puzzle Game In Teaching Vocabulary To The First Gradestudents Of SMPN 3 Proppo. Wacana Didaktika, 5(02), 101-108.          </p>
        </div>
        <div class="element">
          <p class="text ref">
            Vossoughi, H., & Zargar, M. (2009). Using word-search-puzzle games for improving vocabulary knowledge of Iranian EFL learners.           </p>
        </div>
      </div>
    </Section>
    <Footer/>
  </div>
</template>

<script>
import Section from '../../components/Section.vue'
import SideBar from '@/components/SideBar.vue'
import TitleSection from '@/sections/TitleSection.vue'
import ProgressBar from '@/components/ProgressBar.vue'
import SlideShow from '@/components/SlideShow.vue'
import Footer from '../../components/Footer.vue'

export default {
  name: 'App',
  components: {
    TitleSection,
    Section,
    SideBar,
    ProgressBar,
    SlideShow,
    Footer
},
  data () {
    return {
      section_elements: [
        {
          id: 0,
          name: 'iGEM Aachen',
          ref: 'aachen',
          type: 'light'
        },
        {
          id: 1,
          name: 'Bio_Brussels',
          ref: 'brussels',
          type: 'light'
        },
        {
          id: 2,
          name: '',
          ref: 'brussels2',
          type: 'light'
        },
        {
          id: 3,
          name: '',
          ref: 'brussels3',
          type: 'light'
        },
        {
          id: 4,
          name: 'Puzzle Book',
          ref: 'puzzle',
          type: 'light'
        },
        {
          id: 5,
          name: '',
          ref: 'puzzle2',
          type: 'light'
        },
    
        {
          id: 6,
          name: 'Hong Kong',
          ref: 'hongkong',
          type: 'light'
        },
        {
          id: 7,
          name: 'More Collabs',
          ref: 'morecollab',
          type: 'light'
        },
        {
          id: 8,
          name: 'Reference',
          ref: 'reference',
          type: 'dark'
        }
      ],
      slideshow_elements: [
        {
          id: 1,
          src: 'aachen-plushy-1.jpg',
          caption: ''
        },
        {
          id: 2,
          src: 'aachen-plushy-2.jpg',
          caption: ''
        },
        {
          id: 3,
          src: 'aachen-plushy-3.jpg',
          caption: ''
        },
        {
          id: 4,
          src: 'aachen-plushy-4.png',
          caption: ''
        },
      ],
      slideshow_elements_brussels: [
        {
          id: 1,
          src: 'brussels-1.jpeg',
          caption: ''
        },
        {
          id: 2,
          src: 'brussels-2.jpeg',
          caption: ''
        },
        {
          id: 3,
          src: 'brussels-3.jpeg',
          caption: ''
        },
        {
          id: 4,
          src: 'brussels-4.jpeg',
          caption: ''
        },
      
      ],
      slideshow_elements_miniprep: [
        {
          id: 1,
          src: 'miniprep-1.jpg',
          caption: ''
        },
        {
          id: 2,
          src: 'miniprep-2.jpg',
          caption: ''
        }
      ]
    }
  }
}
</script>

<style lang="scss">
  @import '@/assets/scss/main.scss';
</style>



